import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {Modal, Text} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import Util from '../../../shared/util/util';
import DeleteBillToMutation from '../../../../mutations/invoicing/DeleteBillToMutation';

type RemoveBillToModalProps = {
	billToId: string;
	billFromId: string;
	closeModal: () => void;
};

const RemoveBillToModal = ({billToId, billFromId, closeModal}: RemoveBillToModalProps) => {
	const {formatMessage} = useIntl();

	const removeBillTo = (billToId, billFromId) => {
		// This mutation also deletes the client bill to entities linked to
		// the bill to entity being deleted.
		Util.CommitMutation(
			DeleteBillToMutation,
			{
				billToId,
				billFromId,
			},
			closeModal
		);
	};

	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>{formatMessage({id: 'settings_finance.bill_to.remove'})}</Modal.Title>
			<Modal.Content>
				<Text>{formatMessage({id: 'settings_finance.remove_bill_to_entity_confirmation_description'})}</Text>
				<Text>{formatMessage({id: 'settings_finance.remove_bill_to_entity_confirmation_question'})}</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={() => removeBillTo(billToId, billFromId)}>
					{formatMessage({id: 'common.remove'})}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					{formatMessage({id: 'common.close'})}
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export const RemoveBillToModalQuery = graphql`
	query RemoveBillToModalQuery {
		viewer {
			actualPersonId
			component(name: "RemoveBillToModal")
			...RemoveBillToModal_viewer
		}
	}
`;

export default createFragmentContainer(RemoveBillToModal, {
	viewer: graphql`
		fragment RemoveBillToModal_viewer on Viewer {
			id
			company {
				id
				clients(first: 100000) {
					edges {
						node {
							id
							name
							clientBillTos(first: 10000) @connection(key: "Client_clientBillTos", filters: []) {
								edges {
									node {
										id
										billFrom {
											id
										}
										billTo {
											id
										}
										clientId
									}
								}
							}
						}
					}
				}
			}
		}
	`,
});
